export const fetchHistoryData = async (page, pageSize, floor, mac, startTime, endTime) => {
    const _skip = page * pageSize;
    const params = { _skip, _limit: pageSize, floor, mac, startTime, endTime };
    const url = `${process.env.REACT_APP_API_URL}/api/history/list${toQueryString(params)}`;
    const response = await fetch(url);
    if (!response.ok) throw new Error("Failed to fetch history data");
    const total = parseInt(response.headers.get('X-Total-Count'), 10);
    const data = await response.json();
    return { data, total };
};

const toQueryString = (params) => {
    const qs = Object.entries(params)
        .filter(([, v]) => v !== undefined && v !== null && v !== '')
        .map(([k, v]) => `${encodeURIComponent(k)}=${encodeURIComponent(v)}`)
        .join('&');
    return qs ? `?${qs}` : '';
};
